'use client';

import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useContext, useEffect } from 'react';
import { useTransitionTracker } from '../hooks/useTransitionTracker';
import FaqPart from './FaqPart';
import LensDescription from './LensDescription';
import LensPart from './LensPart';
import SeriesOverview from './SeriesOverview';

// 类型定义
interface TransitionLensesData {
  series_overview?: any;
  Lens_description?: any;
  Lens_series1?: any;
  Lens_series2?: any;
  Lens_series3?: any;
  faq_part?: any;
  statement?: string;
  seo_info?: any;
  limit?: number;
}

interface Props {
  transitionData: TransitionLensesData;
}

export default function TransitionLensesContent({ transitionData }: Props) {
  const { trackPageView } = useTransitionTracker();

  const { deviceType } = useContext(ResponsiveContext);
  // 使用deviceType判断是否在App内
  const isInApp = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);

  // 页面加载埋点
  useEffect(() => {
    trackPageView();
  }, [trackPageView]);

  // APP内时监听appView事件（埋点相关）
  useEffect(() => {
    if (isInApp) {
      window.addEventListener('appView', trackPageView);
      return () => {
        window.removeEventListener('appView', trackPageView);
      };
    }
  }, [isInApp, trackPageView]);

  return (
    <>
      {/* 系列概览区域 */}
      <SeriesOverview seriesOverviewData={transitionData.series_overview} />

      {/* 镜片说明区域 */}
      <LensDescription lensDescriptionData={transitionData.Lens_description} />

      {/* 镜片系列1 */}
      <LensPart lensPartData={transitionData.Lens_series1} />

      {/* 镜片系列2 */}
      <LensPart lensPartData={transitionData.Lens_series2} />

      {/* 镜片系列3 */}
      <LensPart lensPartData={transitionData.Lens_series3} />

      {/* FAQ和声明部分 */}
      <FaqPart faqData={transitionData.faq_part} statement={transitionData.statement} />
    </>
  );
}
